import { DETAIL } from './common';

const VARIABLE_OBJECTS = 'variableObjects';

export const variableObjectQueryKeys = {
    all: [VARIABLE_OBJECTS],
    scope: (scopeId?: string, searchTerm?: string) => [VARIABLE_OBJECTS, DETAIL, String(scopeId), String(searchTerm)]
};
